import Icon from '@material-ui/icons/ReportProblemOutlined';
// import Icon from '@material-ui/icons/Clear';
import ReactiveList from './ReactiveList'

export default {
    list: ReactiveList,
    //edit: ShipmentEdit,
    //create: DonorCreate,
    icon: Icon,
};
